import { ApiService } from './api';
import {
  AdminAuthRequest,
  AdminAuthResponse,
  RefreshTokenRequest,
  JWTResponse,
  ApiResponse,
  AdminResponse
} from '../types/auth';

export class AuthService {
  private apiService: ApiService;

  constructor() {
    this.apiService = ApiService.getInstance();
  }

  async authorize(credentials: AdminAuthRequest): Promise<ApiResponse<AdminAuthResponse>> {
    try {
      const response = await this.apiService.post<AdminAuthResponse>('/admin/authorize', credentials);
      
      if (response.token) {
        localStorage.setItem('auth_token', response.token);
        localStorage.setItem('admin_data', JSON.stringify(response.admin));
      }
      
      return {
        data: response,
        success: true
      };
    } catch (error) {
      return {
        error: error instanceof Error ? error.message : 'Authentication failed',
        success: false
      };
    }
  }

  async refreshToken(adminId: number, token: string): Promise<ApiResponse<JWTResponse>> {
    try {
      const request: RefreshTokenRequest = {
        callerId: adminId,
        token: token
      };
      
      const response = await this.apiService.post<JWTResponse>('/admin/refresh-token', request);
      
      if (response.token) {
        localStorage.setItem('auth_token', response.token);
      }
      
      return {
        data: response,
        success: true
      };
    } catch (error) {
      return {
        error: error instanceof Error ? error.message : 'Token refresh failed',
        success: false
      };
    }
  }

  logout(): void {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('admin_data');
  }

  isAuthenticated(): boolean {
    const token = localStorage.getItem('auth_token');
    return !!token;
  }

  getStoredAdmin(): AdminResponse | null {
    const adminData = localStorage.getItem('admin_data');
    if (adminData) {
      try {
        return JSON.parse(adminData);
      } catch (error) {
        console.error('Failed to parse stored admin data:', error);
        return null;
      }
    }
    return null;
  }

  getToken(): string | null {
    return localStorage.getItem('auth_token');
  }
}

export const authService = new AuthService();